import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'

export default class extends Component {
  render() {
    let header = [
      <a href="#/localMerchant/home">我的店铺</a>,
      <a href="#/localMerchant/myShop">商家等级</a>,
      '全款礼'
    ]

    return (
      <HeaderView title="全款礼" header={header}>
        <div style={{ padding: 40 }}>
          <img src="http://qnm.hunliji.com/o_1aa19g8sk1dmik7a1smnvoi1i4a21.jpg" />
          <img src="http://qnm.hunliji.com/o_1aa19g8skk5f1f2t1eklp25rb822.jpg" />
          <img src="http://qnm.hunliji.com/o_1aa19g8sk1l5j1erg1aoh18ad131523.jpg" />
          <img src="http://qnm.hunliji.com/o_1aa19g8sk1i5j16v660b10ct1r4024.jpg" />
        </div>
      </HeaderView>
    )
  }
}
